"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubDashboard = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/dashboard.scss");
var dashboard_utils_1 = require("./utils/dashboard-utils");
var config_1 = require("../config");
var ViewSwitcher_1 = require("../ViewSwitcher/ViewSwitcher");
var DashboardFlow_1 = require("../DashboardFlow/DashboardFlow");
var ProgressView_1 = require("../ProgressView/ProgressView");
var ListView_1 = require("../ListView/ListView");
var addIcon = { iconName: "CircleAddition" };
var createUseCaseMenuProps = {
    items: [
        {
            key: "ukdc",
            text: "UKDC",
            onClick: function () {
                window.open("https://acp201890.sharepoint.com/sites/aihub/Lists/AI%20Hub%20%20Submitted%20Idea%20List/AllItems.aspx", "_blank", "noopener,noreferrer");
            },
        },
        {
            key: "evolve-ai",
            text: "EvolveAI",
            onClick: function () {
                window.open("https://acp201890.sharepoint.com/sites/aihub/Lists/EvolveAIUseCases/AllItems.aspx", "_blank", "noopener,noreferrer");
            },
        },
        {
            key: "icoe",
            text: "ICOE",
            onClick: function () {
                window.open("https://acp201890.sharepoint.com/sites/aihub/Lists/ICOEAIUseCases/AllItems.aspx", "_blank", "noopener,noreferrer");
            },
        },
    ],
};
/**
 * WsAiHubDashboard - Dashboard tab for browsing AI use cases in multiple views.
 *
 * @param {WsAiHubDashboardProps} props - Component props
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubDashboard = function (props) {
    var onImportRunCreated = props.onImportRunCreated, onRefresh = props.onRefresh, _a = props.isImportRunActive, isImportRunActive = _a === void 0 ? false : _a, useCases = props.useCases;
    var _b = react_1.useState("list"), selectedView = _b[0], setSelectedView = _b[1];
    var _c = react_1.useState(false), isImporting = _c[0], setIsImporting = _c[1];
    var _d = react_1.useState(null), message = _d[0], setMessage = _d[1];
    var stageCounts = dashboard_utils_1.getStageCounts(useCases);
    var handleImport = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isImportRunActive) {
                        return [2 /*return*/];
                    }
                    setIsImporting(true);
                    setMessage(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, config_1.getApiPost()('/ai/ukdc/import/runs', {})];
                case 2:
                    _a.sent();
                    setMessage({
                        text: 'Import run started successfully.',
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    return [4 /*yield*/, (onImportRunCreated === null || onImportRunCreated === void 0 ? void 0 : onImportRunCreated())];
                case 3:
                    _a.sent();
                    onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh();
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    setMessage({
                        text: error_1 instanceof Error
                            ? error_1.message
                            : 'Failed to start import run.',
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setIsImporting(false);
                    setTimeout(function () { return setMessage(null); }, 5000);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [isImportRunActive, onImportRunCreated, onRefresh]);
    return (react_1.default.createElement("div", { className: "ws-ai-hub-dashboard" },
        react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-actions" },
            react_1.default.createElement(ViewSwitcher_1.WsAiHubDashboardViewSwitcher, { selectedView: selectedView, onViewChange: setSelectedView }),
            react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-actions-buttons" },
                react_1.default.createElement(office_ui_fabric_react_1.CommandBarButton, { className: "ws-admin-button-hover-accent ws-admin-button-add ws-ai-hub-dashboard-action-button", iconProps: addIcon, text: "Creates new use-case", menuProps: createUseCaseMenuProps }),
                react_1.default.createElement("span", { className: "ws-ai-hub-dashboard-action-separator", "aria-hidden": "true" }),
                react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ws-admin-button-hover-accent ws-ai-hub-dashboard-action-button", iconProps: {
                        iconName: 'Sync',
                        className: isImporting ? "ws-spin" : "",
                    }, disabled: isImporting || isImportRunActive, onClick: handleImport }, isImporting
                    ? 'Starting Import...'
                    : isImportRunActive
                        ? 'Import In Progress'
                        : 'Import New Use Cases'))),
        message && (react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: message.type }, message.text)),
        selectedView === "dashboard" && (react_1.default.createElement(DashboardFlow_1.WsAiHubDashboardFlow, { useCases: useCases, stageCounts: stageCounts })),
        selectedView === "progress" && (react_1.default.createElement(ProgressView_1.WsAiHubDashboardProgressView, { useCases: useCases, stageCounts: stageCounts })),
        selectedView === "list" && (react_1.default.createElement(ListView_1.WsAiHubDashboardListView, { useCases: useCases }))));
};
exports.WsAiHubDashboard = WsAiHubDashboard;
